



















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatUploadButton',
  props: {
    name: { type: String as PropType<string> },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    onFileChange(event: any) {
      const files = event.target.files;
      const fileArray = Object.values(files);

      this.$emit('upload', fileArray);
      this.reset();
    },
    reset() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
});
